import React from "react";
import { Helmet } from "react-helmet-async";
import { BRAND } from "../lib/constants";
import { canonicalUrl, organizationJsonLd, websiteJsonLd } from "../lib/seo";

/**
 * Per-route SEO: title, description, Open Graph, Twitter Card, canonical, JSON-LD.
 */
export default function Seo({
  title,
  description,
  keywords,
  path = "/",
  image,
  type = "website",
  noindex = false,
  jsonLd,
}) {
  const url = canonicalUrl(path);
  const ogImage = image || `${canonicalUrl("")}${BRAND.logo}`;

  const schemas = [
    organizationJsonLd(),
    websiteJsonLd(),
    ...(jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []),
  ];

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={BRAND.name} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content={BRAND.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
